import React, { useEffect, useState } from "react";
import ReservationModal from "./ui/ReservationModal";

/**
 * Lightweight, invisible host that owns the Book Stripe checkout
 * modal at the App-shell level. The previous design embedded the
 * modal inside <BookSection>, which meant removing the section from
 * the homepage also broke every "am:open-book-checkout" dispatcher
 * across the site (Final CTA, Reciprocity panels, Snapshot result
 * redirect, /start-here ladder, etc.). Mounting it once at the
 * Landing route preserves the global event contract regardless of
 * whether the visible book section is currently rendered.
 */
const BookCheckoutHost = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("am:open-book-checkout", handler);
    return () => window.removeEventListener("am:open-book-checkout", handler);
  }, []);

  return (
    <ReservationModal
      open={open}
      onClose={() => setOpen(false)}
      product="book"
      testIdPrefix="book"
      eyebrow="Continue to Checkout"
      title="Step into the first chapter."
      description="Secure checkout via Stripe. You will be redirected to complete your purchase."
      submitLabel="Buy Authentic Momentum · $19.99"
      busyLabel="Preparing checkout…"
    />
  );
};

export default BookCheckoutHost;
